import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { setupKeyboardInset } from './keyboardInset.js'

// Dự phòng nâng ô soạn tin lên trên bàn phím ảo cho WebView không hiểu interactive-widget.
setupKeyboardInset()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
